import { render, staticRenderFns } from "./AuditNameForm.vue?vue&type=template&id=bcb6f586&scoped=true&"
import script from "./AuditNameForm.vue?vue&type=script&lang=js&"
export * from "./AuditNameForm.vue?vue&type=script&lang=js&"
import style0 from "./AuditNameForm.vue?vue&type=style&index=0&id=bcb6f586&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb6f586",
  null
  
)

export default component.exports